<div
  id="userLoggedOut"
  class="errorpage"
  data-cy="loggedout-page">
  <div class="errorpage-logo-container">
    <img
      src="assets/allianz-logo.png"
      alt="allianz-logo"
      class="errorpage-logo-img" />
  </div>
  <div class="errorpage-content">
    <img
      src="assets/illustration_logout.svg"
      alt="allianz-logo"
      class="errorpage-warn-img" />
    <div class="errorpage-headline">{{ "logoutPage.header" | text }}</div>
    <div class="errorpage-msg">{{ "logoutPage.text" | text }}</div>
  </div>
</div>
